import classNames from 'classnames';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

interface HeaderProps {
  children: React.ReactNode;
  className?: string;
  dataTestAttrs?: DataTestAttrs;
}

export function Header1(props: HeaderProps): JSX.Element {
  return <h1 className={classNames(props.className, 'header--header1')}>{props.children}</h1>;
}

export function Header2(props: HeaderProps): JSX.Element {
  return (
    <h2 className={classNames(props.className, 'header--header2')} {...getTestProps(props.dataTestAttrs)}>
      {props.children}
    </h2>
  );
}

export function Header3(props: HeaderProps): JSX.Element {
  return <h3 className={classNames(props.className, 'header--header3')}>{props.children}</h3>;
}

export function Title(props: HeaderProps): JSX.Element {
  return <h3 className={classNames(props.className, 'header--title')}>{props.children}</h3>;
}

export function Sublabel(props: HeaderProps): JSX.Element {
  return <div className={classNames(props.className, 'header--sublabel')}>{props.children}</div>;
}

interface PrefixedHeaderProps extends HeaderProps {
  prefix: string;
}
export function PrefixedHeader(props: PrefixedHeaderProps): JSX.Element {
  return (
    <Header1 className={props.className}>
      <span className="font-proxima-semibold">{props.prefix}</span> | {props.children}
    </Header1>
  );
}
